import { render } from "./NotFound404.vue?vue&type=template&id=fe275eaa"
import script from "./NotFound404.vue?vue&type=script&lang=js"
export * from "./NotFound404.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__